import React from "react";

function NoLayoutView({ children }: React.PropsWithChildren<unknown>) {
    return (
        <div id="wrapper">
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <div className="p-2">{children}</div>
                </div>
            </div>
        </div>
    );
}
export default NoLayoutView;
